import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DialogContext } from './contexts';
import Dialog from './Dialog';
import DialogButton from './DialogButton';

const ACTION_PREFIX = 'ACTION_';

DialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default function DialogProvider({ children }) {
  const [dialogs, setDialogs] = useState([]);

  const genOpenDialog = (icon) => (genOptions) => {
    const createdActions = [];
    const genCreateAction = (className) => (label) => {
      createdActions.push({ label, className });
      return `${ACTION_PREFIX}${createdActions.length - 1}`;
    };
    const action = genCreateAction();
    action.alert = genCreateAction('lw_btn_alert_40');

    const { title, description, onClose, cancel, ...actions } =
      genOptions(action);
    const props = {
      icon,
      title,
      description,
      onClose: () => {
        setDialogs((dialogs) => dialogs.slice(0, -1));
        _.isFunction(onClose) && onClose();
      },
      children: (
        <>
          {_.isNil(cancel) || cancel === false ? null : (
            <DialogButton.Cancel>
              {cancel === true ? undefined : cancel}
            </DialogButton.Cancel>
          )}
          {createdActions.map(({ label, className }, index) => (
            <DialogButton.Action
              key={index}
              className={className}
              onSelect={actions[`${ACTION_PREFIX}${index}`]}
            >
              {label}
            </DialogButton.Action>
          ))}
        </>
      ),
    };

    setDialogs((dialogs) => [...dialogs, props]);
  };

  const dialog = genOpenDialog();
  dialog.alert = genOpenDialog('alert');
  dialog.confirm = genOpenDialog('confirm');

  const location = useLocation();
  useEffect(() => {
    setDialogs([]);
  }, [location]);

  return (
    <DialogContext.Provider value={{ dialog }}>
      {children}
      {dialogs.map((props, index) => (
        <Dialog key={index} {...props} />
      ))}
    </DialogContext.Provider>
  );
}
